
export const Message = ({
    className,
    message,
    style,
    onDismiss = () => {},
}) => {
    
    return (
        
        <div className={className ?? '' + ' ' + (message.style ?? '')} style={style}>
            
            <div
                className={`py-2 flex justify-between alert alert-${message.level ?? 'info'} `}
                role="alert">
                
                {message.text}
                
                <button
                    className="close"
                    type="button"
                    data-dismiss="alert"
                    aria-label="Close"
                    onClick={onDismiss}>
                    <span aria-hidden="true">&times;</span>
                </button>
            
            </div>
        
        </div>
        
    )
    
}
